/* Live To-Do box: numbered task lines for today. Glass + 3D shadow come from
 * the shared .glass .glass--solid utilities; this module is layout + type. */

.box {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: clamp(16px, 1.6vw, 28px) clamp(18px, 1.8vw, 32px);
  gap: clamp(10px, 1vh, 18px);
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
}

.title {
  margin: 0;
  flex: 0 0 auto;
  font-family: var(--token-font-display);
  font-size: clamp(28px, 2.6vw, 48px);
  letter-spacing: 0.5px;
}

.list {
  margin: 0;
  padding-left: clamp(24px, 2vw, 40px);
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1vh, 16px);
}

.item {
  font-family: var(--token-font-body);
  font-size: clamp(22px, 1.8vw, 32px);
  line-height: 1.4;
  padding-left: 6px;
}

.empty {
  margin: 0;
  font-family: var(--token-font-body);
  font-size: clamp(20px, 1.7vw, 28px);
  color: rgba(28, 38, 32, 0.55);
}
